import { __spreadArray } from "tslib";
import loadSvgCached from './load-svg-cached';
import loadSvgUncached from './load-svg-uncached';
import uniqueId from './unique-id';
var injectedElements = [];
var ranScripts = {};
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';
var injectElement = function (el, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, callback) {
    var elUrl = el.getAttribute('data-src') || el.getAttribute('src');
    if (!elUrl) {
        callback(new Error('Invalid data-src or src attribute'));
        return;
    }
    if (injectedElements.indexOf(el) !== -1) {
        injectedElements.splice(injectedElements.indexOf(el), 1);
        el = null;
        return;
    }
    injectedElements.push(el);
    el.setAttribute('src', '');
    var loadSvg = cacheRequests ? loadSvgCached : loadSvgUncached;
    loadSvg(elUrl, httpRequestWithCredentials, function (error, svg) {
        if (!svg) {
            injectedElements.splice(injectedElements.indexOf(el), 1);
            el = null;
            callback(error);
            return;
        }
        var elId = el.getAttribute('id');
        if (elId) {
            svg.setAttribute('id', elId);
        }
        var elTitle = el.getAttribute('title');
        if (elTitle) {
            svg.setAttribute('title', elTitle);
        }
        var elWidth = el.getAttribute('width');
        if (elWidth) {
            svg.setAttribute('width', elWidth);
        }
        var elHeight = el.getAttribute('height');
        if (elHeight) {
            svg.setAttribute('height', elHeight);
        }
        var mergedClasses = Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], (svg.getAttribute('class') || '').split(' '), true), [
            'injected-svg'
        ], false), (el.getAttribute('class') || '').split(' '), true)))
            .join(' ')
            .trim();
        svg.setAttribute('class', mergedClasses);
        var elStyle = el.getAttribute('style');
        if (elStyle) {
            svg.setAttribute('style', elStyle);
        }
        svg.setAttribute('data-src', elUrl);
        var elData = [].filter.call(el.attributes, function (at) {
            return /^data-\w[\w-]*$/.test(at.name);
        });
        Array.prototype.forEach.call(elData, function (dataAttr) {
            if (dataAttr.name && dataAttr.value) {
                svg.setAttribute(dataAttr.name, dataAttr.value);
            }
        });
        if (renumerateIRIElements) {
            var iriElementsAndProperties_1 = {
                clipPath: ['clip-path'],
                'color-profile': ['color-profile'],
                cursor: ['cursor'],
                filter: ['filter'],
                linearGradient: ['fill', 'stroke'],
                marker: ['marker', 'marker-start', 'marker-mid', 'marker-end'],
                mask: ['mask'],
                path: [],
                pattern: ['fill', 'stroke'],
                radialGradient: ['fill', 'stroke'],
            };
            var element_1;
            var elements_1;
            var properties_1;
            var currentId_1;
            var newId_1;
            Object.keys(iriElementsAndProperties_1).forEach(function (key) {
                element_1 = key;
                properties_1 = iriElementsAndProperties_1[key];
                elements_1 = svg.querySelectorAll(element_1 + '[id]');
                var _loop_1 = function (a, elementsLen) {
                    currentId_1 = elements_1[a].id;
                    newId_1 = currentId_1 + '-' + uniqueId();
                    var referencingElements;
                    Array.prototype.forEach.call(properties_1, function (property) {
                        referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId_1 + '"]');
                        for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
                            var attrValue = referencingElements[b].getAttribute(property);
                            if (attrValue &&
                                !attrValue.match(new RegExp('url\\("?#' + currentId_1 + '"?\\)'))) {
                                continue;
                            }
                            referencingElements[b].setAttribute(property, 'url(#' + newId_1 + ')');
                        }
                    });
                    var allLinks = svg.querySelectorAll('[*|href]');
                    var links = [];
                    for (var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++) {
                        var href = allLinks[c].getAttributeNS(xlinkNamespace, 'href');
                        if (href && href.toString() === '#' + elements_1[a].id) {
                            links.push(allLinks[c]);
                        }
                    }
                    for (var d = 0, linksLen = links.length; d < linksLen; d++) {
                        links[d].setAttributeNS(xlinkNamespace, 'href', '#' + newId_1);
                    }
                    elements_1[a].id = newId_1;
                };
                for (var a = 0, elementsLen = elements_1.length; a < elementsLen; a++) {
                    _loop_1(a, elementsLen);
                }
            });
        }
        svg.removeAttribute('xmlns:a');
        var scripts = svg.querySelectorAll('script');
        var scriptsToEval = [];
        var script;
        var scriptType;
        for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
            scriptType = scripts[i].getAttribute('type');
            if (!scriptType ||
                scriptType === 'application/ecmascript' ||
                scriptType === 'application/javascript' ||
                scriptType === 'text/javascript') {
                script = scripts[i].innerText || scripts[i].textContent;
                if (script) {
                    scriptsToEval.push(script);
                }
                svg.removeChild(scripts[i]);
            }
        }
        if (scriptsToEval.length > 0 &&
            (evalScripts === 'always' ||
                (evalScripts === 'once' && !ranScripts[elUrl]))) {
            for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
                new Function(scriptsToEval[l])(window);
            }
            ranScripts[elUrl] = true;
        }
        var styleTags = svg.querySelectorAll('style');
        Array.prototype.forEach.call(styleTags, function (styleTag) {
            styleTag.textContent += '';
        });
        svg.setAttribute('xmlns', svgNamespace);
        svg.setAttribute('xmlns:xlink', xlinkNamespace);
        beforeEach(svg);
        if (!el.parentNode) {
            injectedElements.splice(injectedElements.indexOf(el), 1);
            el = null;
            callback(new Error('Parent node is null'));
            return;
        }
        el.parentNode.replaceChild(svg, el);
        injectedElements.splice(injectedElements.indexOf(el), 1);
        el = null;
        callback(null, svg);
    });
};
export default injectElement;
//# sourceMappingURL=inject-element.js.map